import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { getLocaleString } from "lib/localization/vendor";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";

export default function StyleMeasureFeature(feature: Feature<Geometry>) {
	const colorHex = "#FFA500";
	const sizeInfo: string = feature.get("size-info");

	return [
		new Style({
			stroke: new Stroke({
				color: colorHex,
				width: 3
			}),
			fill: new Fill({
				color: "rgba(255, 165, 0, 0.2)",
			}),
			image: new CircleStyle({
				radius: 6,
				fill: new Fill({
					color: colorHex,
				}),
				stroke: new Stroke({
					color: "black",
					width: 1,
				}),
			}),
			text: new Text({
				font: 'bold 14px "Helvetica Neue", "Arial", san-serif',
				textBaseline: "middle",
				backgroundFill: new Fill({
					color: "rgba(0,0,0,0.5)",
				}),
				fill: new Fill({
					color: "white",
				}),
				text: sizeInfo ? `${getLocaleString("measurement")}\n` + sizeInfo : "",
				padding: [3, 2, 2, 2],
			}),
		}),
	];
}
